// src/pages/LoginPage.js
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../firebase";
import { Box, Typography, CircularProgress } from "@mui/material";
import GoogleOneTapLogin from "../components/auth/GoogleOneTapLogin";
import LoginWithGoogle from "../components/auth/LoginWithGoogle";

const LoginPage = () => {
  const { user, loading } = useAuth();
  const navigate = useNavigate();
  const [redirecting, setRedirecting] = useState(false);

  useEffect(() => {
    const redirectIfReady = async () => {
      if (!user || loading) return;

      try {
        setRedirecting(true);
        const userRef = doc(db, "users", user.uid);
        const userSnap = await getDoc(userRef);

        if (!userSnap.exists()) {
          navigate("/register-child");
          return;
        }

        const data = userSnap.data();
        if (!data.children || data.children.length === 0) {
          navigate("/register-child");
        } else {
          navigate(`/tracker/${data.children[0]}`);
        }
      } catch (error) {
        console.error("Error fetching user data:", error);
        setRedirecting(false);
      }
    };

    redirectIfReady();
  }, [user, loading, navigate]);

  return (
    <Box
      sx={{
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        padding: 2,
        textAlign: "center",
      }}
    >
      <Typography
        variant="h4"
        gutterBottom
        sx={{ fontWeight: "bold" }}
      >
        Login kræves
      </Typography>
      <Typography
        variant="body1"
        sx={{ marginBottom: 2 }}
      >
        Du skal være logget ind for at fortsætte.
      </Typography>

      <GoogleOneTapLogin />
      <LoginWithGoogle />

      {(loading || redirecting) && (
        <>
          <CircularProgress sx={{ mt: 4 }} />
          <Typography sx={{ mt: 2 }}>
            {redirecting ? "Omdirigerer..." : "Logger ind..."}
          </Typography>
        </>
      )}
    </Box>
  );
};

export default LoginPage;
